import React from "react";
import Panel from "@radarly/components/panel/fullscreen";
import { useClosePanel } from "@radarly/core/panel/use-cases";
import { CardEditionPanel } from "@radarly/models/panel";
import PanelCardEdition from "./panel";

interface SharedPanelsCardEditionProps {
  panel: CardEditionPanel;
}

export default function SharedPanelsCardEdition({
  panel,
}: SharedPanelsCardEditionProps) {
  const onClosePanel = useClosePanel();
  const onClose = () => {
    onClosePanel("card-edition");
  };
  const onValidatePanel = (card) => {
    panel.onValidate(card);
    onClose();
  };
  return (
    <Panel>
      <PanelCardEdition
        onClose={onClose}
        card={panel.card}
        onValidate={onValidatePanel}
        timezone={panel.editedPage.timezone}
        aiContext={panel.editedPage.aiContext}
        setAIContext={panel.setAIContext}
        globalPeriod={panel.globalPeriod}
        pageColors={panel.pageColors}
      />
    </Panel>
  );
}
